import React from 'react';
import PropTypes from 'prop-types';
import styles from './TldrBlock.sass';

const TldrBlock = ({ text, className }) => (
  <div className={`${styles.root} ${className}`}>
    <div className={styles.content}>
      <div className={styles.referenceNumberSection}>What It Means:</div>
      <div className={styles.textSection}>{text}</div>
    </div>
  </div>
);

TldrBlock.defaultProps = {
  className: '',
};

TldrBlock.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default TldrBlock;
